







/* 
--------- NO EDITAR -----------







Editar el sheet de Google docs:

https://docs.google.com/spreadsheets/d/1UJZkk-HrMMsjKUSlIDbxWpxXUVOZfH2iYgXZWmUCEqk/edit#gid=736972915

y correr despues el script con: 
yarn run import-lang
*/







const t = { "clave": `es`,
"enroll_form_pending": `enroll_form_pending`,
"identity_document_pending": `identity_document_pending`,
"course_access_document_pending": `course_access_document_pending`,
"certified_course_access_document_pending": `certified_course_access_document_pending`,
"Volver": `Volver`,
"Completa tu matriculación": `Completa tu matriculación`,
"Subtitulo completa tu matriculacion": `Facilita la información pendiente para formalizar tu matrícula en el Departamento de Educación:`,
"Información personal y académica": `Información personal y académica`,
"Formulario de matrícula": `Formulario de matrícula`,
"Información de acceso al ciclo": `Información de acceso al ciclo`,
"Documento de identidad": `Documento de identidad`,
"Documentos de acceso": `Documentos de acceso`,
"Enviar copia de titulación": `Enviar copia de titulación`,
"Ayuda": `Una vez validada la información personal y académica (punto anterior), deberás enviar la copia de tu titulación.`,
"Pendiente": `Pendiente`,
"Enviado": `Enviado`,
"Validando": `Validando`,
"Revisar": `Revisar`,
"Validado": `Validado`,
"Completa formulario información personal": `Completa el formulario con tu información personal:`,
"Campos obligatorios": `* Campos obligatorios`,
"Nombre": `Nombre`,
"Primer apellido": `Primer apellido`,
"Segundo apellido": `Segundo apellido`,
"Género": `Género*`,
"Femenino": `Femenino`,
"Masculino": `Masculino`,
"Fecha nacimiento*": `Fecha de nacimiento*`,
"País nacimiento": `País de nacimiento`,
"Población nacimiento": `Población de nacimiento`,
"Lugar residencia*": `Lugar de residencia*`,
"País residencia": `País de residencia`,
"Tipo vía": `Tipo de vía`,
"Nombre vía": `Nombre de la vía`,
"Núm": `Núm.`,
"Bloq": `Bloq.`,
"Escal": `Escal.`,
"Piso": `Piso`,
"Puerta": `Puerta`,
"Código Postal": `Código Postal`,
"Población": `Población`,
"Teléfono contacto": `Teléfono de contacto`,
"Últimos estudios": `Últimos estudios realizados`,
"Indica últimos estudios": `Indica los últimos estudios que has realizado, anteriores al ciclo de que te estás matriculando.`,
"Tipo estudios": `Tipo de estudios`,
"Último año académico": `Último año académico`,
"Seguro pregunta": `Seguro que deseas salir? Se perderán los cambios`,
"Completa información documento identidad": `Completa la información de tu documento de identidad.`,
"Nacionalidad": `Nacionalidad`,
"DNI": `DNI`,
"Pasaporte": `Pasaporte`,
"NIE": `NIE`,
"Número documento": `Número de documento`,
"Documento válido": `Documento válido hasta:`,
"Fotos del DNI:": `Añade el DNI:`,
"Cara frontal": `Cara frontal`,
"Cara trasera": `Cara trasera`,
"Tipo de documento": `Tipo de documento:`,
"Fotos DNI": `Documento de identidad:`,
"Foto frontal": `Cara frontal:`,
"Foto warning": `El texto debe ser legible. Tiene que tener buena iluminacion, estar enfocado y no tener destellos.`,
"Foto pasaporte": `Añadir el pasaporte`,
"Añadir foto imagen": `Añadir `,
"Foto frontal NIE": `Añadir frontal del NIE`,
"Foto trasera NIE": `Añadir trasera del NIE`,
"Foto frontal NIF": `Añadir frontal del NIF`,
"Foto trasera NIF": `Añadir trasera del NIF`,
"Documento no correcto": `El documento de identidad que has añadido no es correcto.`,
"Fotos no legibles danger": `Las fotos del documento que has añadido no son legibles. Por favor, vuelve a añadirlas procurando que toda la información se pueda leer bien.`,
"DNI no correcto danger": `El documento de identidad que has añadido no es correcto.`,
"Validación fecha danger": `Introduce la fecha de caducidad del nuevo documento, además las fotos de cada una de las caras`,
"NIE ejemplo": `El NIE consta de una letra inicial (X, Y, Z), 7 números y una letra. Ej.: X1111111A`,
"DNI ejemplo": `El DNI consta de 8 números y una letra. Ej.: 11111111A`,
"Completa la información de tu NIE": `Completa la información de tu NIE`,
"Completa la información de tu DNI": `Completa la información de tu DNI`,
"Completa la información de tu pasaporte": `Completa la información de tu pasaporte`,
"Completa información": `Completa la información:`,
"Titulación accedes ciclo": `Titulación con la que accedes al ciclo`,
"Titulación acceso": `Titulación de acceso`,
"consulta requisitos acceso": `Consulta los requisitos de acceso`,
"Título pregunta": `¿Tienes el título a tu disposición? *`,
"Tiene título": `Sí`,
"No tiene título": `No, todavía no lo tengo`,
"Nota final": `Nota final`,
"No nota final": `Si no tienes nota final, por favor, introduce el número 5`,
"Subir foto danger": `Por favor, añade el título`,
"Subir foto titulo": `Añade el título`,
"Título añadido danger": `El título que has añadido, no se corresponde con el título de acceso que has indicado. Por favor, añade el título correcto.`,
"Foto resguardo tasas": `Añadir foto del resguardo por tasas`,
"Foro certificado notas": `Añadir foto del certificado de notas`,
"Selecciona archivo": `Selecciona el archivo`,
"<strong>Añade resguardo pago</strong>": `Añade el <strong>resguardo de pago de tasas de la solicitud de expedición del título</strong> (como máximo de 2 años de antigüedad), junto con el <strong>certificado de notas oficial:</strong> `,
"Resguardo pago danger": `El resguardo del pago que has añadido no se corresponde con el título de acceso que has indicado. Por favor, añade el resguardo de pago de tasas correcto.`,
"Resguardo tasas título": `Resguardo por tasas`,
"Certificado notas título": `Certificado de notas`,
"Añadir foto": `Añadir`,
"Requisitos acceso": `Requisitos de acceso`,
"Texto requisito acceso": `
    <p>Para matricularte a un ciclo de Grado Medio, debes tener más de 18 años o cumplirlos durante el año natural del comienzo del ciclo. Además, tienes que cumplir al menos uno de los siguientes requisitos académicos:</p>
    <ul>
    <li>Tener el título de Graduado de Educación Secundaria Obligatoria (ESO).</li>
    <li>Tener el Graduado en Educación Secundaria (GES).</li>
    <li>Tener el título de Técnico/a o de Técnico/a auxiliar.</li>
    <li>Haber superado el curso específico para el acceso a los ciclos formativos de Grado Medio (CAM).</li>
    <li>Haber superado el segundo curso del Bachillerato Unificado y Polivalente (BUP).</li>
    <li>Tener otros estudios equivalentes a efectos académicos.</li>
    <li>Haber superado los módulos obligatorios de un programa de cualificación profesional inicial (PCPI).</li>
    <li>Haber superado la Prueba de Acceso a la Universidad para mayores de 25 años.</li>
    <li>Tener un título para acceder a un ciclo formativo de Grado Superior.</li>
    <li>Haber superado la prueba de acceso a un ciclo de Grado Medio.</li>
    </ul>
    <p>Para matricularte a un ciclo de Grado Superior, debes tener más de 18 años o cumplirlos durante el año natural del comienzo del ciclo. Además, tienes que cumplir al menos uno de los siguientes requisitos académicos:</p>
    <ul>
    <li>Tener el título de Bachillerato.</li>
    <li>Tener el título de Técnico/a (ciclo de Grado Medio, CFGM).</li>
    <li>Tener el título de Técnico/a superior o especialista (ciclo de Grado Superior, CFGS).</li>
    <li>Tener el título Bachillerato Unificado Polivalente (BUP).</li>
    <li>Haber superado el segundo curso de Bachillerato de cualquier modalidad de Bachillerato experimental.</li>
    <li>Haber superado el Curso de Orientación Universitaria (COU) o el preuniversitario.</li>
    <li>Tener cualquier titulación universitaria o una equivalente.</li>
    <li>Haber superado la prueba de acceso en la Universidad para mayores de 25 años.</li>
    <li>Haber superado la prueba de acceso que te acredite para estudiar tu ciclo de Grado Superior deseado.</li>
    </ul>`,
"copia compulsada": `Para finalizar el proceso de matriculación, debes enviarnos una copia compulsada del título de acceso al ciclo a nuestra sede de ILERNA Online. Mientras tanto podrás cursar tu formación con normalidad.`,
"Resguardo de pago": `Resguardo de pago de tasas de expedición del título.`,
"Certificado notas": `Certificado de notas oficial.`,
"Dirección de envío": `Dirección de envío`,
"ILERNA Online": `ILERNA Online`,
"Turó de Gardeny": `Turó de Gardeny, Complex Magical Media`,
"Edificio": `Edificio 5, 25003 - Lleida`,
"Anulación matrícula": `Si antes de la fecha no hemos recibido el título, procederemos a la anulación de tu matrícula.`,
"Condiciones venta": `Ver condiciones de venta.`,
"Copia título alert danger": `La copia del título que nos has enviado no está compulsada. Debes enviarnos la copia compulsada para poder tramitar tu expediente con el Departamento de Educación.`,
"Datos alumno": `Tus datos`,
"Nombre y apellidos": `Nombre y apellidos`,
"Sexo": `Sexo`,
"Fecha nacimiento": `Fecha de nacimiento`,
"Número DNI": `Número de DNI`,
"Actualizar DNI": `Actualizar documento de identidad`,
"Cambiar residencia": `Cambiar lugar de residencia`,
"Cambiar teléfono": `Cambiar teléfono de contacto`,
"Cambiar nee": `Cambiar necesidades educativas`,
"Nee": `Necesidades educativas especiales`,
"Lugar residencia": `Lugar de residencia`,
"Teléfono": `Teléfono`,
"Necesidades Educativas": `Necesidades Educativas`,
"Selecciona nee": `Selecciona una necesidad educativa`,
"Historial de matrículas": `Historial de matrículas`,
"Detalle de matrícula": `Detalle de matrícula`,
"Pedir nuevo": `Pedir de nuevo`,
"Resumen asignaturas": `Resumen de asignaturas`,
"Descargar factura": `Descargar factura`,
"No referencia": `No se indicó la referencia`,
"Fecha": `Fecha`,
"Matrícula": `Matrícula`,
"Importe": `Importe`,
"Método pago": `Método de pago`,
"Estado": `Estado`,
"Cerrar": `cerrar`,
"Cambiar contraseña": `Cambiar contraseña`,
"Tu cuenta": `Tu cuenta`,
"Dirección": `Dirección`,
"Código postal": `Código postal`,
"País": `País`,
"Guardar": `Guardar`,
"Contraseña actual": `Contraseña actual`,
"Nueva contraseña": `Nueva contraseña`,
"Confirmar contraseña": `Confirmar contraseña`,
"contraseña no coincide": `Las contraseñas no coinciden`,
"Accede al campus": `Accede al campus`,
"Cerrar sesión": `Cerrar sesión`,
"Select error": `Debes seleccionar un campo.`,
"Rango contraseña": `La contraseña debe tener 8 caracteres como mínimo`,
"Error no manejado": `Error no manejado`,
"Error texto": `Debes introducir un texto`,
"Error numero": `Debes introducir un numero`,
"Error telefono": `Debes introducir un teléfono correcto`,
"Escriba una población válida": `Escriba una población válida`,
"Todavía no te has matriculado en ILERNA.": `Todavía no te has matriculado en ILERNA.`,
"Matrícúlate ahora": `Matrícúlate ahora`,
"completa matricula": `Facilita la información que está pendiente para que podamos completar tu matrícula.`,
"estamos validando": `Estamos validando la información que has aportado. Te avisaremos de cualquier posible incidencia.`,
"hemos detectado error": `Hemos detectado alguna incidencia en la información que has aportado. Por favor, revísala.`,
"help_documentos_acceso": `Una vez validada la información personal y académica (punto anterior), deberás enviar la copia de tu titulación.`,
"data.name": `Por favor, escribe tu nombre`,
"data.first_name": `Por favor, escribe tu apellido`,
"data.gender.id": `Por favor, selecciona uno`,
"data.birth_date": `Por favor, indica tu fecha de nacimiento`,
"data.birth_date_day": `Por favor, indica tu día de nacimiento`,
"data.birth_date_month": `Por favor, indica tu mes de nacimiento`,
"data.birth_date_year": `Por favor, indica tu año de nacimiento`,
"data.birth_country.id": `Por favor, selecciona el país de nacimiento`,
"data.birth_city.id": `Por favor, escribe la población de nacimiento`,
"data.birth_city_name": `Por favor, escribe la población de nacimiento`,
"address.via_type.id": `Por favor, selecciona el tipo de vía`,
"address.name": `Por favor, escribe el nombre de la vía`,
"address.number_address": `Escribe el número`,
"address.zip_code": `Por favor, escribe el código postal`,
"address.city.id": `Por favor, escribe la población`,
"address.city_name": `Por favor, escribe la población`,
"address.country_name": `Por favor, selecciona el país`,
"address.phone": `Por favor, escribe tu teléfono de contacto`,
"data.nee.id": `Por favor, selecciona una necesidad educativa o ninguna`,
"last_course.id": `Por favor, selecciona el tipo de estudios`,
"last_course.academic_year": `Por favor, selecciona el último año académico`,
"type.id": `Por favor, selecciona el título de acceso`,
"grade": `Por favor, escribe la nota final`,
"reference": `Por favor, introduce el número de documento`,
"country.id": `Por favor, selecciona tu nacionalidad`,
"expires_at": `Por favor, indica la fecha de validez`,
"expires_at_day": `Por favor, indica el día`,
"expires_at_month": `Por favor, indica el mes`,
"expires_at_year": `Por favor, indica el año`,
"address_name": `Por favor, escribe la dirección`,
"address_city_name": `Por favor, escribe la población`,
"address_country_name": `Por favor, selecciona el país`,
"address_zip_code": `Por favor, escribe el código postal`,
"Tipos de vía frecuentes": `Tipos de vía frecuentes`,
"Listado alfabético": `Listado alfabético`,
"Inicio": `Inicio`,
"Fecha nacimiento exemple": `Por ejemplo: 20 11 1984`,
"Consulta los detalles": `Consulta los detalles`,
"Puedes subir PDF": `Puedes escanear el documento y después añadir el archivo, o puedes subir las fotos directamente desde tu móvil.<br><br>
<ul><li>Asegúrate de que todo el texto del documento se pueda leer bien.</li>
<li>Si haces una foto, evita el flash para que se enfoque e ilumine bien.</li>
<li>Añade archivos PDF, DOC, JPEG ó PNG, de 5 MB como máximo.</li>
</ul>`,
"Aviso compulsa": `Para formalizar tu expediente académico, necesitaremos copias compulsadas de tus documentos de acceso. Cuando hayamos verificado toda tu información de matrícula en formato digital, te pediremos que nos envíes las copias compulsadas por correo postal.<br/><br/>
                            Si aportas una copia compulsada digital de un documento, o bien el documento tiene un Código Seguro de Verificación (CSV), no será necesario que nos envíes por correo postal una copia en papel del mismo.`,
"Se ha subido el archivo correctamente": `Se ha subido el archivo correctamente`,
"Completa tu matricula": `Completa tu matrícula`,
"Clases presenciales": `Clases presenciales`,
"Exámenes": `Exámenes`,
"Expediente": `Expediente`,
"Información personal": `Información personal`,
"Selecciona una necesidad educativa": `Selecciona una necesidad educativa`,
"Actualizar": `Actualizar`,
"Reembolsada": `Reembolsada`,
"Congelada": `Congelada`,
"Error": `Error`,
"Actualizar datos": `Actualizar datos`,
"¿Has olvidado la contraseña?": `¿Has olvidado la contraseña?`,
"Resumen de productos": `Resumen de productos`,
"No hay mensajes todavía ...": `No hay mensajes todavía ...`,
"Comunicado": `Comunicado`,
"Cargando": `Cargando`,
"a las": `a las`,
"min de lectura": `min de lectura`,
"Tus datos se han guardado correctamente": `Tus datos se han guardado correctamente`,
"La contraseña se ha cambiado correctamente": `La contraseña se ha cambiado correctamente`,
"Tu contraseña se ha restablecido correctamente.": `Tu contraseña se ha restablecido correctamente.`,
"access_title": `Título acceso al ciclo`,
"payment_fees": `Pago tasas`,
"grade_cert": `Certificado de notas`,
"Resguardo pago tasas": `Resguardo pago tasas`,
"Certificado de notas": `Certificado de notas`,
"Tus pedidos": `Tus pedidos`,
"Detalle de pedido": `Detalle de pedido`,
"Bloque": `Bloque`,
"Editar": `Editar`,
"Escalera": `Escalera`,
"Número": `Número`,
"Ninguna": `Ninguna`,
"El DNI no es valido": `El DNI no es válido`,
"Toma una foto": `Toma una foto`,
"Comunicados": `Comunicados`,
"Campus": `Campus`,
"formalizar matricula alert": `Los datos que introduzcas deben ser exactamente igual que los que aparecen en tu Documento de Identidad (acentos, guiones, mayúsculas, minúsculas)`,
"Expedición del título": `Expedición del título`,
"Pago de tasas": `Pago de tasas`,
"Dirección de envío del título": `Dirección de envío del título`,
"Antes de abonar las tasas,<strong> debes verificar la dirección de envío</strong> y actualizarla, si es necesario:": `Antes de abonar las tasas,<strong> debes verificar la dirección de envío</strong> y actualizarla, si es necesario:`,
"Actualizar dirección": `Actualizar dirección`,
"Aceptar y continuar": `Aceptar y continuar`,
"Pagar tasas": `Pagar tasas`,
"Para solicitar tu título es necesario <strong>pagar las tasas de expedición del título</strong>": `Para solicitar tu título es necesario <strong>pagar las tasas de expedición del título</strong>`,
"<strong>En el caso de que no estés exento/a del pago de tasas</strong>, debes realizar el pago aquí:": `<strong>En el caso de que no estés exento/a del pago de tasas</strong>, debes realizar el pago aquí:`,
"titulo-payment-success": `En un plazo máximo de 15 días desde la fecha del pago de tasas, recibirás por correo certificado urgente la documentación que acredita que has finalizado tu formación. <br/> <br/>
        Los documentos que recibirás tienen la misma validez que el título oficial que nos llegará a nuestra sede en un plazo aproximado de dos años. <br/> <br/>
        Podrás seguir el envío a través de un enlace que te proporcionará la empresa de correos GLS.`,
"Documentación provisional enviada": `Documentación provisional enviada`,
"titulo-docu-sent": `<ul>
            <li class='m-bottom-half'>Certificado de notas completo del ciclo formativo original (+ dos copias compulsadas).</li>
            <li class='m-bottom-half'>Justificante del pago de las tasas de la expedición del título (+ dos copias compulsadas).</li>
            <li class='m-bottom-half'>Resguardo de la solicitud del título oficial (+ dos copias compulsadas).</li>
        </ul>`,
"titulo-docu-sent-warning": `La documentación enviada acredita que has finalizado tu formación. Los documentos tienen la misma validez que el título oficial, el cuál nos llegará a nuestra sede en un plazo aproximado de 2 años desde el momento de la solicitud <br/>
            <br/>
            <strong>Contactaremos contigo para indicarte el protocolo de entrega del título oficial.</strong>`,
"titulo-docu-sent-pedir-encuesta": `Agradecemos mucho la confianza que has depositado en nosotros para formarte, por ello es <strong>IMPORTANTE</strong> que contestes esta encuesta:`,
"Valoración del servicio recibido": `Valoración del servicio recibido`,
"Lee las consideraciones previas para la formalización de la matrícula, y firma el documento.": `Lee las consideraciones previas para la formalización de la matrícula, y firma el documento.`,
"Deja tu firma aquí": `Deja tu firma aquí`,
"Borrar": `Borrar`,
"Aceptar": `Aceptar`,
"Consideraciones previas para la formalización de la matrícula": `Consideraciones previas para la formalización de la matrícula`,
"Contacta con tu gestor": `Contacta con tu gestor`,
"Contacta con tu gestor a través de WhatsApp": `Contacta con tu gestor a través de WhatsApp`,
"Para añadir la información de contacto de tu gestor Premium a WhatsApp puedes escanear el código QR de WhatsApp.": `Para añadir la información de contacto de tu gestor Premium a WhatsApp puedes escanear el código QR de WhatsApp.`,
"Si tu móvil es Android:": `Si tu móvil es Android:`,
"Si tu móvil es iPhone:": `Si tu móvil es iPhone:`,
"whatsapp-nuevo-chat": `Abre WhatsApp > pulsa "Nuevo chat":`,
"Pulsa el icono de QR junto a Nuevo contacto:": `Pulsa el icono de QR junto a Nuevo contacto:`,
"Selecciona <b>ESCANEAR CÓDIGO</b> y coloca tu dispositivo sobre el código QR para escanearlo.": `Selecciona <b>ESCANEAR CÓDIGO</b> y coloca tu dispositivo sobre el código QR para escanearlo.`,
"Pulsa <strong>AÑADIR.</strong>": `Pulsa <strong>AÑADIR.</strong>`,
"Pulsa <strong>Nuevo contacto > Añadir a través de código QR</strong>": `Pulsa <strong>Nuevo contacto > Añadir a través de código QR</strong>`,
"Coloca tu dispositivo sobre el código QR para escanearlo o pulsa el icono de <strong>Fotos</strong> en la parte inferior de la pantalla y selecciona el código QR de WhatsApp desde tus <strong>Fotos</strong>": `Coloca tu dispositivo sobre el código QR para escanearlo o pulsa el icono de <strong>Fotos</strong> en la parte inferior de la pantalla y selecciona el código QR de WhatsApp desde tus <strong>Fotos</strong>`,
"Pulsa <strong>Añadir contactos.</strong>": `Pulsa <strong>Añadir contactos.</strong>`,
"Para cualquier consulta, puedes contactar con tu gestor a través de Whatsapp.": `Para cualquier consulta, puedes contactar con tu gestor a través de Whatsapp.`,
"Código QR": `Código QR`,
"state": `Por favor, introduce una provincia`,
"zip": `Por favor, introduce un código postal`,
"city": `Por favor, introduce una población`,
"title": `Por favor, introduce un título para la oferta`,
"maxJobs": `Por favor, introduce el número de vacantes`,
"contractType": `Por favor, introduce el tipo de contrato`,
"schedule": `Por favor, introduce la jornada laboral`,
"companyName": `Por favor, introduce un nombre alternativo`,
"presence": `Por favor, selecciona una modalidad`,
"name": `Por favor, introduce el nombre`,
"surname": `Por favor, introduce los apellidos`,
"phone": `Por favor, introduce el teléfono`,
"email": `Por favor, introduce el correo electrónico`,
"nif_validate": `Por favor, introduce un identificador valido.`,
"subtitle": `Por favor, introduce el sector de la empresa`,
"empleados": `Por favor, introduce el número de trabajadores`,
"text": `Por favor, introduce la descripción de tu empresa`,
"location": `Por favor, introduce la ubicación`,
"links[1].url": `Por favor, introduce un link de linkedin correcto`,
"links[0].url": `Por favor, introduce un link de infojobs correcto`,
"salaryType": `Por favor, introduce un tipo de salario`,
"salaryMin": `Por favor, introduce un salario minimo`,
"salaryMax": `Por favor, introduce un salario maximo`,
"Informacion general": `Información general`,
"Requisito tecnico": `Requisitos técnicos para cursar la formación online`,
"liceale conseguita": ``,
"Titulo de acceso": `Título de acceso:`,
"Diploma di scuola": `Título de acceso`,
"acerca del servicio": `acerca del servicio`,
"Plazos de tramitación": `Plazos de tramitación`,
"Los plazos de tramitación y entrega de la documentación son de <strong>10 a 15 días laborables,</strong> a partir del momento de la recepción de documentación (en el caso de exención al pago de tasas) y del pago de las tasas.": `Los plazos de tramitación y entrega de la documentación son de <strong>10 a 15 días laborables,</strong> a partir del momento de la recepción de documentación (en el caso de exención al pago de tasas) y del pago de las tasas.`,
"Tarifas de solicitud del título": `Tarifas de solicitud del título`,
"service-policy-tax": `<p>Ciclo Formativo de Grado Medio (CFGM): <strong>79€</strong></p><p>Ciclo Formativo de Grado Superior (CFGM): <strong>89€</strong></p>`,
"Documentación que recibirás": `Documentación que recibirás`,
"Pasados los 10 a 15 días recibirás por correo certificado la documentación que acredita que has finalizado tu formación. Recibirás el resguardo de pago de tasas, que <strong>tiene la misma validez que el título oficial,</strong> así como el certificado de notas del ciclo formativo y el justificante de pago de la tasas. Es importante no entregar nunca el original, ya que es el equivalente al titulo hasta que este llegue en un <strong>plazo aproximado de 2 años.</strong>": `Pasados los 10 a 15 días recibirás por correo certificado la documentación que acredita que has finalizado tu formación. Recibirás el resguardo de pago de tasas, que <strong>tiene la misma validez que el título oficial,</strong> así como el certificado de notas del ciclo formativo y el justificante de pago de la tasas. Es importante no entregar nunca el original, ya que es el equivalente al titulo hasta que este llegue en un <strong>plazo aproximado de 2 años.</strong>`,
"Podrás seguir el envío a través de un enlace que te proporcionará la empresa de correos.": `Podrás seguir el envío a través de un enlace que te proporcionará la empresa de correos.`,
"guardar cambios": `guardar cambios`,
"cancelar": `cancelar`,
"Actualizar dirección de envío": `Actualizar dirección de envío`,
"Pago de tasas realizado correctamente": `Pago de tasas realizado correctamente`,
"En un plazo máximo de 15 días desde la fecha del pago de tasas, recibirás por correo certificado urgente la documentación que acredita que has finalizado tu formación": `En un plazo máximo de 15 días desde la fecha del pago de tasas, recibirás por correo certificado urgente la documentación que acredita que has finalizado tu formación`,
"Los documentos que recibirás tienen la misma validez que el título oficial que nos llegará a nuestra sede en un plazo aproximado de dos años": `Los documentos que recibirás tienen la misma validez que el título oficial que nos llegará a nuestra sede en un plazo aproximado de dos años`,
"Podrás seguir el envío a través de un enlace que te proporcionará la empresa de correos GLS": `Podrás seguir el envío a través de un enlace que te proporcionará la empresa de correos GLS`,
"Consideraciones previas para la formalización de la matrícula": `Consideraciones previas para la formalización de la matrícula`,
"Empieza tu FP a distancia": `Empieza tu FP a distancia`,
"Para empezar a estudiar tu FP a distancia en {MONTH} y obtener tu titulación oficial, debes matricularte. Tu Experiencia ILERNA no tiene validez académica.": `Para empezar a estudiar tu FP a distancia en {MONTH} y obtener tu titulación oficial, debes matricularte. Tu Experiencia ILERNA no tiene validez académica.`,
"address_province_name": `Por favor, selecciona la provincia `,
"Solicitud de revisión enviada correctamente": `Solicitud de revisión enviada correctamente`,
"Ha sucedido un error con la subida del archivo": `Ha sucedido un error con la subida del archivo`,
"Ha sucedido un error con la descarga del archivo": `Ha sucedido un error con la descarga del archivo`,
"Seleccione el idioma": `Seleccione el idioma`,
"Sector de la empresa a mostrar": `Sector de la empresa a mostrar`,
"Datos de contacto correo": `Cambiar correo electrónico`,
"ene": `ene`,
"feb": `feb`,
"mar": `mar`,
"abr": `abr`,
"may": `may`,
"jun": `jun`,
"jul": `jul`,
"ago": `ago`,
"sep": `sep`,
"oct": `oct`,
"nov": `nov`,
"dic": `dic`,
"Motivos seguridad": `Por motivos de seguridad, introduce la contraseña de ILERNA para continuar.`,
"Datos de contacto password": `Cambiar contraseña`,
"Datos de contacto": `Cambiar datos de contacto`,
"Error password": `Contraseña incorrecta`,
"No se ha podido cambiar la contraseña": `No se ha podido cambiar la contraseña`,
"Teletrabajo": `Teletrabajo`,
"vacante": `vacante`,
"vacantes": `vacantes`,
"Proceso Online": `PROCESO ONLINE`,
"Página web de ILERNA": `Página web de ILERNA`,
"Contraseña operacion": `La contraseña es obligatoria para completar la operación`,
"Parece que el formato del video es incorrecto.": `Parece que el formato del video es incorrecto.`,
"Parece que el formato de la web es incorrecto.": `Parece que el formato de la web es incorrecto.`,
"Cambiar correo electrónico": `Cambiar correo electrónico`,
"Cambiar datos de contacto": `Cambiar datos de contacto`,
"Bolsa de trabajo | ILERNA": `Bolsa de trabajo | ILERNA`,
"Publicar oferta | ILERNA": `Publicar oferta | ILERNA`,
"Datos de usuario | ILERNA": `Datos de usuario | ILERNA`,
"Cambiar correo electrónico | ILERNA": `Cambiar correo electrónico | ILERNA`,
"Datos de contacto password | ILERNA": `Datos de contacto password | ILERNA`,
"Cambiar datos de contacto | ILERNA": `Cambiar datos de contacto | ILERNA`,
"Perfil de empresa | ILERNA": `Perfil de empresa | ILERNA`,
"Registro | ILERNA": `Registro | ILERNA`,
"Las preguntas del cuestionario no se pueden editar porque ya hay candidatos inscritos en la oferta.": `Las preguntas del cuestionario no se pueden editar porque ya hay candidatos inscritos en la oferta.` };

export default t;
